export default "/images/CDL_Local_Logo.jpg?74492a697da16aa70320f68069a13107";